import React from 'react';
import { Box, BoxProps } from 'rebass';
import { radii, colors } from '../../theme';

interface TableCellProps extends React.ComponentProps<any> {
  onClick?: React.UIEventHandler;
}

export const TableHeader: React.FC = ({ children }) => (
  <Box as={'thead'}>{children}</Box>
);

export const TableBody: React.FC<{
  'data-testid'?: string;
}> = ({ children, ...props }) => (
  <Box as={'tbody'} {...props}>
    {children}
  </Box>
);

export const TableRow: React.FC = ({ children }) => (
  <Box as={'tr'}>{children}</Box>
);

export const TableName: React.FC = ({ children }) => (
  <Box
    variant={'table'}
    sx={{
      background: colors.tableHeader,
      borderRadius: `${radii.medium} ${radii.medium} 0px 0px`,
    }}
  >
    {children}
  </Box>
);

export const TableColHead: React.FC<TableCellProps> = ({
  children,
  onClick,
  ...props
}) => {
  return (
    <Box as={'th'} onClick={onClick} variant={'tableHeader'} {...props}>
      {children}
    </Box>
  );
};

export const TableCell: React.FC<TableCellProps> = ({
  children,
  onClick,
  ...props
}) => (
  <Box as={'td'} variant={'tableCell'} onClick={onClick} {...props}>
    {children}
  </Box>
);

export interface TableProps extends Omit<BoxProps, 'css'> {}
export const Table: React.FC<TableProps> = props => (
  <Box variant={'table'} as={'table'} {...props}>
    {props.children}
  </Box>
);
